import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=a45ae29c&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=a45ae29c&prod&lang=css"
import style1 from "./teacher.vue?vue&type=style&index=1&id=a45ae29c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ae29c",
  null
  
)

export default component.exports